import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { columns } from './utils'
import { getSmartOosData } from 'utils/api/smartOosApi'
import { useQuery } from 'hooks'

type Props = {
  refetch: boolean
}

const SmartOosTable = ({ refetch }: Props) => {
  const [response, setResponse] = useState<any>({})

  const { search } = useLocation()
  const { getQuery } = useQuery()

  const fetchSmartOosDetails = async () => {
    try {
      const { data } = await getSmartOosData({
        limit: getQuery('limit') || 10,
        page: getQuery('page') || 1,
      })
      setResponse({ ...data })
    } catch (error) {
      setResponse({ docs: [] })
    }
  }

  useEffect(() => {
    fetchSmartOosDetails()
  }, [search, refetch])

  return (
    <>
      <DataTable columns={columns} rows={response?.docs} identifier="_id" />
      <DataTablePagination
        currentPage={response?.page}
        totalPages={response?.totalPages}
        hasNextPage={response?.hasNextPage}
        hasPrevPage={response?.hasPrevPage}
        limit={response?.limit}
        nextPage={response?.nextPage}
        prevPage={response?.prevPage}
      />
    </>
  )
}

export default SmartOosTable
